import styled from 'styled-components'

export const StyledWrapper = styled.section`
  width: 580px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 50px 70px;
  gap: 30px;
`

export const StyledSubTitle = styled.span`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
`
